/** Meshtek staff (and the TeamTech QA identities): the audience for internal links such as the QA Tracker. */
const STAFF_DOMAINS = ['@meshtek.io', '@teamtech.guru'] as const;

export function isInternalStaffEmail(email: string | null | undefined): boolean {
  if (typeof email !== 'string') return false;
  const e = email.trim().toLowerCase();
  return STAFF_DOMAINS.some((d) => e.endsWith(d));
}
